import { date, mixed, number, object, SchemaOf, string } from 'yup';

import { getDateWithProperTimeOffset } from '@/utils/date.utils';
import { ContractOriginEnum } from '@/graphql/contracts/_generated_/contracts';


export interface ContractHeadersList {
  customerID: UUID;
  contractStartDate: Date | undefined;
  term: number | string;
  contractNumber: string;
  renewableTerm: number | string;
  currency: string;
  origin: ContractOriginEnum | undefined;
  shipToCustomerId: UUID | undefined;
  invoiceToCustomerId: UUID | undefined;
  clientDatabaseId: string | undefined;
}

export const contractHeadersIntialValues: ContractHeadersList = {
  customerID: '',
  contractStartDate: getDateWithProperTimeOffset(
    new Date(new Date().setHours(0, 0, 0, 0)),
  ),
  term: '',
  contractNumber: '',
  renewableTerm: '',
  currency: '',
  origin: undefined,
  shipToCustomerId: undefined,
  invoiceToCustomerId: undefined,
  clientDatabaseId: undefined,
};

export const contractHeadersValidationSchema: SchemaOf<ContractHeadersList> = object().shape({
  customerID: string()
    .required('You must specify a Customer'),

  contractStartDate: date()
    .typeError('Must be a correct date: dd/mm/yyyy')
    .required('You must enter a Contract Start Date'),

  term: number()
    .typeError('Contract Term must be a number')
    .positive('Contract Term must be a positive number')
    .integer('Contract Term must be an integer')
    .required('You must enter a Contract Term'),

  contractNumber: string()
    .min(1, 'Must be at least ${min} character')
    .max(200, 'Must be maximum ${max} characters')
    .required('You must enter a Contract Number'),

  renewableTerm: number()
    .typeError('Renewable Term must be a number')
    .integer('Renewable Term must be an integer')
    .required('You must enter a Renewable Term'),

  currency: string()
    .required(),

  origin: mixed<ContractOriginEnum>()
    .oneOf(Object.values(ContractOriginEnum), 'Invalid Contract Origin')
    .required('You must specify the Contract\'s Origin'),

  shipToCustomerId: string()
    .optional(),

  invoiceToCustomerId: string()
    .optional(),

  clientDatabaseId: string()
    .optional(),
});
